import React, { useState, useEffect } from 'react';

const EditNewsTickerModal = ({ isOpen, onClose, initialData }) => {
  const [tickerData, setTickerData] = useState({
    items: [
      "🌟 Summer Health Checkup Package - 30% Off! Book now!",
      "🆓 Free Doctor Consultation on First Visit - Limited time offer",
      "🏢 Corporate Health Packages - Special rates for companies",
      "🩺 Advanced Radiology Tests - 15% Discount this month"
    ],
    label: "Latest Offers"
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchTickerData = async () => {
      if (isOpen && !initialData) {
        setIsLoading(true);
        try {
          const response = await fetch(`${import.meta.env.VITE_API_URL}/layout/news-ticker/`);
          if (response.ok) {
            const data = await response.json();
            setTickerData(data);
          }
        } catch (error) {
          console.error('Error fetching news ticker data:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchTickerData();
  }, [isOpen, initialData]);

  useEffect(() => {
    if (initialData) {
      setTickerData(initialData);
    }
  }, [initialData]);

  const handleItemChange = (index, value) => {
    const newItems = [...tickerData.items];
    newItems[index] = value;
    setTickerData(prev => ({ ...prev, items: newItems }));
  };

  const addItem = () => {
    setTickerData(prev => ({ 
      ...prev, 
      items: [...prev.items, "New ticker item"] 
    }));
  };

  const removeItem = (index) => {
    const newItems = [...tickerData.items];
    newItems.splice(index, 1);
    setTickerData(prev => ({ ...prev, items: newItems }));
  };

  const handleLabelChange = (e) => {
    setTickerData(prev => ({ ...prev, label: e.target.value }));
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${import.meta.env.VITE_API_URL}/layout/news-ticker/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tickerData)
      });

      if (response.ok) {
        onClose();
        window.location.reload();
      } else {
        throw new Error('Failed to update news ticker');
      }
    } catch (error) {
      console.error('Error updating news ticker:', error);
      alert('Failed to save changes. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <dialog className="modal modal-open">
        <div className="modal-box">
          <div className="flex flex-col items-center justify-center p-8">
            <span className="loading loading-spinner loading-lg"></span>
            <p className="mt-4">Loading news ticker data...</p>
          </div>
        </div>
      </dialog>
    );
  }

  return (
    <dialog className={`modal ${isOpen ? 'modal-open' : ''}`}>
      <div className="modal-box w-11/12 max-w-3xl max-h-[90vh] relative">
        <button onClick={onClose} className="btn btn-sm btn-circle absolute right-2 top-2">✕</button>
        <h3 className="font-bold text-lg mb-6">Edit News Ticker</h3>
        
        <div className="overflow-y-auto max-h-[70vh] pr-2 space-y-6">
          {/* Ticker Label */}
          <div className="form-control">
            <label className="label">
              <span className="label-text">Ticker Label</span>
            </label>
            <input
              type="text"
              value={tickerData.label}
              onChange={handleLabelChange}
              className="input input-bordered w-full"
            />
          </div>

          {/* Ticker Items */}
          <div className="card bg-base-100 shadow-sm p-4">
            <div className="flex justify-between items-center mb-4">
              <h4 className="font-bold">Ticker Items ({tickerData.items.length})</h4>
              <button onClick={addItem} className="btn btn-sm btn-primary">
                Add Item
              </button>
            </div>
            
            <div className="space-y-2">
              {tickerData.items.map((item, index) => (
                <div key={index} className="flex gap-2 items-center">
                  <input
                    type="text"
                    value={item}
                    onChange={(e) => handleItemChange(index, e.target.value)}
                    className="input input-bordered flex-grow"
                  />
                  <button 
                    onClick={() => removeItem(index)} 
                    className="btn btn-sm btn-error"
                    disabled={tickerData.items.length <= 1}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="modal-action mt-6">
          <button onClick={onClose} className="btn">Cancel</button>
          <button 
            onClick={handleSubmit} 
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default EditNewsTickerModal;